import { useContext } from "react";
import traking from "../../../lib/event/tracker";
import styles from "./index.module.css";
import { ThemeContext } from "../../../contexts/theme";
import {motion} from "framer-motion";

const ScrollerNavigation = ({ pageNumber, pageLength, setPageNumber }) => {
  const theme = useContext(ThemeContext);
  const isActive = (i) => {
    return pageNumber == i;
  };
  const handleClick = (name, i) => {
    setPageNumber(i);
    traking({ eventAction: "click", eventName: name });
  };

  return (
    <motion.div
        initial={{ opacity: 0, x: -10 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.3,duration: 0.5 }}
        className={styles.controls}>
      {Array(pageLength)
        .fill(0)
        .map((e, i) => {
          return (
            <div
              key={i}
              className={
                styles.controlsPoints +
                (isActive(i) ? " " + styles.active : "") +
                (theme.name == "dark" ? " " + styles.controlsPointsDark : "")
              }
              id={i}
              onClick={() => handleClick("goToPage" + i, i)}
            ></div>
          );
        })}
    </motion.div>
  );
};

export default ScrollerNavigation;
